<template>
    <layout-basic>
        <v-container fluid>
            <v-layout row wrap>
                <v-row style="margin-bottom: 44px">
                    <v-flex xs4 class="py-5">
                        <div class="reporting_div">
                            <div class="text-xs-center px-0 mx-auto"><strong>Total Users:</strong></div>
                            <div class="text-xs-center px-0 mx-auto">{{ totalUsers }}</div>
                        </div>
                        <div class="reporting_div">
                            <div class="text-xs-center px-0 mx-auto"><strong>Total Courses:</strong></div>
                            <div class="text-xs-center px-0 mx-auto">{{ totalCourses }}</div>
                        </div>
                    </v-flex>
                    <v-flex xs4>
                        <v-card flat class="pa-3" height="100%">
                            <v-card-text class="px-0">
                                <h3>Most Popular</h3>
                                <apexchart
                                :options="barChartOptions"
                                :series="barSeries"
                                type="bar"
                                height="350"
                                />
                            </v-card-text>
                        </v-card>
                    </v-flex>
                    <v-flex xs4>
                        <v-card flat height="100%" class="pa-3">
                            <v-card-text class="px-0">
                                <h3>Completed Courses</h3>
                                <apexchart
                                :options="pieChart.chartOptions"
                                :series="pieChart.series"
                                type="donut"
                                width="380"
                                />
                            </v-card-text>
                        </v-card>
                    </v-flex>
                </v-row>
            </v-layout>
            <v-row>
                <v-col md="12">
                    <v-card flat>
                        <v-card-title>
                            <div class="flex-grow-1"></div>
                        </v-card-title>
                        <v-data-table
                        :headers="headers"
                        :options.sync="options"
                        :server-items-length="serverItemsLength"
                        :loading="loading"
                        :items="users"
                        >
                        </v-data-table>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </layout-basic>
</template>

<script>
    import userAPI from "@/api/partner.js";
    import LayoutBasic from "@/layouts/PartnerHub";
    import VueApexCharts from "vue-apexcharts";
    export default {
        name: "UsersReport",
        components: {
            LayoutBasic,
            apexchart: VueApexCharts
        },
        data() {
            return {
                headers: [
                    { text: "First Name", value: "first_name" },
                    { text: "Surname", value: "last_name" },
                    { text: "Email", value: "email" },
                    { text: "Last Login", value: "last_login", sortable: false },
                    { text: "Total Users", value: "total_customer_users", sortable: false },
                    { text: "Total Courses", value: "total_customer_courses", sortable: false },
                    { text: "Total Groups", value: "total_customer_groups", sortable: false },
                    { text: "Total Playlists", value: "total_customer_playlists", sortable: false },
                ],
                users: [],
                search: "",
                searchParams: "",
                pagination: {},
                options: {},
                loading: false,
                totalUsers: 0,
                totalCourses: 0,
                bar: {},
                pie: {},
                pieChart: {
                    series: [0],
                    chartOptions: {
                        dataLabels: {
                            enabled: false
                        },
                        labels: ["Not Started", "Completed", "In progress"],
                        responsive: [
                        {
                            breakpoint: 480,
                            options: {
                                chart: {
                                    width: 200
                                },
                                legend: {
                                    show: false
                                }
                            }
                        }],
                        legend: {
                            position: "right",
                            offsetY: 0,
                            height: 230
                        }
                    }
                },
            };
        },
        computed: {
            serverItemsLength: function() {
                return this.pagination.total;
            },
            itemsPerPage: function() {
                return this.pagination.per_page;
            },
            page: function() {
                return this.pagination.current_page;
            },
            params: function() {
                return this.$gf.getQueryString(this.options, this.serverItemsLength);
            },
            barSeries() {
                return [
                {
                    name: "Total Users",
                    data: this.bar.series
                }];
            },
            barChartOptions() {
                return {
                    plotOptions: {
                        bar: {
                            horizontal: true
                        }
                    },
                    dataLabels: {
                        enabled: false
                    },
                    tooltip: {
                        enabled: false
                    },
                    xaxis: {
                        categories: this.bar.categories,
                        tickAmount: 3,
                        labels: {
                            formatter: function(val) {
                                return val.toFixed(0);
                            }
                        }
                    }
                };
            }
        },
        watch: {
            options: {
                handler() {
                    this.getCustomers();
                    this.getReports();
                },
                deep: true
            }
        },
        methods: {
            getCustomers() {
                this.loading = true;
                userAPI.getOwners(this.params, this.searchParams, this.$route.params.id).then(resp => {
                    this.users = resp.data.data;
                    this.pagination = resp.data.meta.pagination;
                    if(resp.data.data.length > 0) {
                        for(var i=0; i<resp.data.data.length; i++) {
                            this.totalUsers = this.totalUsers + resp.data.data[i].total_customer_users;
                            this.totalCourses = this.totalCourses + resp.data.data[i].total_customer_courses;
                        }
                    }
                    this.loading = false;
                });
            },
            resetSearch() {
                this.searchParams = "";
                this.getCustomers();
            },
            applySearch() {
                this.searchParams = this.params + "&search=first_name:" + this.search + ";last_name:" + this.search;
                this.getCustomers();
            },
            pieC() {
                this.pieChart = {
                    series: this.pie.map(x => {
                        return x;
                    })
                };
            },
            getReports() {
                userAPI.getPartnerCustomerReports(this.$route.params.id).then(response => {
                    if(response.data){
                        this.bar = response.data.bar;
                        this.pie = response.data.pie;
                    }
                    this.pieC();
                });
            }
        }
    };
</script>
